export default __webpack_public_path__ + "static/media/01.f5ecbb14.jpg";